<div class="customers-batch-upload-card">
  <div ubi-curve-header class="customers-batch-upload-card__header">
    <div class="customers-batch-upload-card__header-text">
     {{ 'customer_batch_upload.header' | translate }}
    </div>
  </div>
  <artemis-popover>
    <ng-container *ngFor="let section of ('customer_batch_upload.info.content' | translate)">
      {{ section.text }}
      <a class="link link_underlined link_accent" (click)="getCustomersBatchUploadTemplate()">{{ section.here }}</a>
      <u>{{section.header}}</u>
      <ul>
        <ng-container *ngFor="let content of section.array">
          <li>{{content}}</li>
        </ng-container>
      </ul>
    </ng-container>
  </artemis-popover>
  <div class="customers-batch-upload-card__content">
    <artemis-loading-spinner *ngIf="isFileProcessing">
    </artemis-loading-spinner>
    <div class="customers-batch-upload-card__addfile">
      <mat-form-field floatLabel="never" class="custom-mat-form-field customers-batch-upload-card__file">
        <input #fileText [ngModel]="selectedFile?.name" disabled matInput placeholder="{{ 'customer_batch_upload.form.label.file_name' | translate }}" type="text">
      </mat-form-field>
      <input hidden (change)="fileUploadedChange($event.target.files)" type="file" #fileInput [accept]="allowedFileFormats">
      <button class="customers-batch-upload-card__add-file-button" ubi-round-button mat-stroked-button
              (click)="fileInput.click()">
        {{ 'customer_batch_upload.button.add' | translate }}
      </button>
    </div>
    <button class="btn_accent-gradient-rounded customers-batch-upload-card__upload-button" mat-button ubi-round-button
            (click)="batchUpload()">
      {{ 'customer_batch_upload.button.process' | translate }}
    </button>
  </div>
</div>
